import { Routes } from '@angular/router';
import { DayAheadEmbedComponent } from './components/day-ahead-embed/day-ahead-embed.component';

// This app is now a widget-only host. It serves the day-ahead embed at
// /embed/day-ahead (iframed by the customer's own website). All marketing
// pages + the Strapi-backed slug routes were removed; anything else redirects
// to the embed. The whole host is noindex (see index.html + web.config).
export const routes: Routes = [
  { path: 'embed/day-ahead', component: DayAheadEmbedComponent },
  { path: '**', redirectTo: 'embed/day-ahead' },
];
